// extracted by mini-css-extract-plugin
module.exports = {"nutritionStyle":"_2vr4MEHpGTMktjgK0s2ac3"};